<ng-container *ngIf="(isCCci$ | async) === true; else isCCriOrCCxi">
  <div class="cc-footer-links">
    <div class="cc-grid-container cc-footer-links__list-container">
      <ul class="cc-footer-links__list">
        <li class="cc-footer-links__list-item" *ngFor="let link of footerLinks$ | async">
          <ccwb-text size="m">
            <a class="cc-link" href="{{ link?.link }}" target="_blank" rel="noopener">{{ link?.label }}</a>
          </ccwb-text>
        </li>
      </ul>
    </div>
  </div>
</ng-container>

<ng-template #isCCriOrCCxi>
  <cc-dealer-locator location="footer" />
</ng-template>
